module.exports = __webpack_public_path__ + "static/media/remove-thin-24.16c1cc7a.svg";